import styled from '@emotion/styled';

import Card from 'components/global/Card';
import LottiePlayer from 'components/global/LottiePlayer';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
`;
export const InnerContainer = styled(Card)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 60dvw;
	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;
export const LottieStyled = styled(LottiePlayer)`
	width: 30rem;

	@media ${Breakpoints.mobile} {
		width: 20rem;
	}
`;
